// Teks lama "Semester & Tahun Masuk" (field semester_tahun_masuk, teks bebas dari data
// awal) -- ARSIP BACA-SAJA, ditampilkan sbg acuan prodi saat mengisi Semester & Periode
// Masuk. Tidak pernah bisa diedit dari tabel/form, dan tidak diolah jadi nilai apa pun.
export const TEKS_LAMA_MAKS_TABEL = 32;

export function teksLama(peserta) {
    const v = peserta?.semester_tahun_masuk;
    return typeof v === "string" ? v.trim() : "";
}

// Potong utk sel tabel; teks lengkap tetap ada di atribut title (tooltip) & form Edit.
export function ringkasTeksLama(teks, maks = TEKS_LAMA_MAKS_TABEL) {
    const t = (teks || "").trim();
    if (!t) return "";
    return t.length > maks ? `${t.slice(0, maks - 1).trimEnd()}…` : t;
}
